import { Grid } from '@mui/material';
import React from 'react'
import './scss/tab.component.scss';

export default function CustomTab(
    {
        data,
        containerStyle,
        CustomComp,
    }: {
        data: { title: string | React.ReactNode }[],
        containerStyle?: React.CSSProperties,
        CustomComp: (anything: any) => JSX.Element,
    }) {
    return (
        <Grid className='tab-component'
            style={{ ...containerStyle }}
            container
            direction='row'
            maxWidth={600}
            alignItems='flex-start'
            spacing={2}
        >
            {
                data.map((e, i) => (
                    <Grid item key={i} className='itemContainer'>
                        <CustomComp row={e} index={i} />
                    </Grid>
                ))
            }
        </Grid>
    )
}

